import { render } from "./refusalReasonDialog.vue?vue&type=template&id=cd70d62c"
import script from "./refusalReasonDialog.vue?vue&type=script&lang=js"
export * from "./refusalReasonDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__